import { createContext, useCallback, useContext, useMemo, useState } from "react"

export const AnnualPlanContext = createContext()

export function AnnualPlanProvider({ category, children }) {
	const [selectArea, setSelectArea] = useState("")
	const [selectCategory, setSelectCategory] = useState("")
	const [selectYears, setSelectYears] = useState("")
	const [filterCourses, setFilterCourses] = useState({
		year: "",
		category: "",
		area: "",
	})
	const setFilter = useCallback(
		(field, value) => setFilterCourses((old) => ({ ...old, [field]: value })),
		[]
	)

	const datos = useMemo(
		() => ({
			// category,
			selectArea,
			selectCategory,
			selectYears,
			setSelectArea,
			setSelectCategory,
			setSelectYears,
			filterCourses,
			setFilterCourses,
			setFilter,
		}),
		[filterCourses, selectArea, selectCategory, selectYears, setFilter]
	)

	return (
		<AnnualPlanContext.Provider value={datos}>{children}</AnnualPlanContext.Provider>
	)
}
/**
 * Hook personalizado que proporciona acceso al contexto del fondo.
 * @typedef {Object}  paramsContext Control de plan anual
 * @property {array} category Las categorías de capacitación.
 * @property {number} selectArea valor del select.
 * @property {number} selectCategory valor del select.
 * @property {number} selectYears valor del select.
 * @property {function} setSelectArea UsesState para editar el valor.
 * @property {function} setSelectCategory UsesState para editar el valor.
 * @property {function} setSelectYears UsesState para editar el valor.
 */
/**
 *
 * @returns {paramsContext} .
 */
export function useAnnualPlanContext() {
	return useContext(AnnualPlanContext)
}
